import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { BodyCopy } from '@xingternal/typography';

import { useSerpsMatch, useTopCategories } from '../../../serps/hooks';
import { capitalizeFirstLetter } from '../../../serps/utils';

import { AverageSalary, Container, SalaryCard, SalaryRoleDescription, Title } from './salary-data.styles';

const getFormattedNumber = (value: number): string =>
  value.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export const SalaryData: React.FC = () => {
  const { formatMessage } = useIntl();
  const serps = useSerpsMatch();
  const { relatedJobRoleSalaryStatistics } = useTopCategories();
  const { maximum, median, minimum } = relatedJobRoleSalaryStatistics || {};
  const isStatisticsEmpty = !relatedJobRoleSalaryStatistics || Object.keys(relatedJobRoleSalaryStatistics).length === 0;

  if (isStatisticsEmpty || median === 0) {
    return null;
  }

  return (
    <Container>
      <Title size="large" sizeConfined="xlarge">
        {formatMessage(
          { id: 'XJM_JOBS_SEO_ROLE_SALARY_HEADER' },
          { jobRole: capitalizeFirstLetter(serps?.categoryValue || '') }
        )}
      </Title>
      {median ? (
        <SalaryCard>
          <AverageSalary as="div">{getFormattedNumber(median || 0)} €</AverageSalary>
          <BodyCopy size="large" lineHeight="dense" noMargin>
            {formatMessage({ id: 'XJM_JOBS_SEO_ROLE_SALARY_LABEL' })}
          </BodyCopy>
        </SalaryCard>
      ) : null}
      <SalaryRoleDescription noMargin>
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_SALARY_DESCRIPTION"
          values={{
            jobRole: capitalizeFirstLetter(serps?.categoryValue || ''),
            maximumSalary: <strong>{getFormattedNumber(maximum || 0)}€</strong>,
            minimumSalary: <strong>{getFormattedNumber(minimum || 0)}€</strong>,
            averageSalary: getFormattedNumber(median || 0),
          }}
        />
      </SalaryRoleDescription>
    </Container>
  );
};
